// src/pages/dashboard/components/WeightChartCard.jsx
import WeightChart from "../../../../components/charts/WeightChart";

export default function WeightChartCard({ userId, series = [], color = "#7EDBB6" }) {
    return (
        <div
            className="
        px-3 py-7 bg-white rounded-2xl
        border border-gray-200
        grid grid-cols-[1fr_auto] gap-4
        items-center
      "
        >
            <div>
                <WeightChart series={series} color={color} />
            </div>
        </div>
    );
}
